import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import axiosClient from 'api/axiosClient';
import Loader from "react-loader-spinner";
import { Container, Row, Col } from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { toDateTimeStringEnglish } from '../../../utils/utils';
import { useIntl } from 'react-intl';

import { IMAGE_BASE_URL } from 'utils/constants';
import './style.css'; // Import file CSS đã tách riêng

export default function Cooperation() {
    const intl = useIntl();
    
    const [listPartners, setListPartners] = useState([]);
    const [infoCoop, setInfoCoop] = useState({});
    const [loaded, setLoaded] = useState(false);
    const [linkImage, setLinkImage] = useState("");

    useEffect(() => {
        setLoaded(false);

        // Fetch danh sách Partners
        axiosClient.get('/partners?page=1&size=50&unit=Home')
            .then(response => {
                const data = response.data || [];
                setListPartners(data);
            })
            .catch(error => {
                console.error('Lỗi khi tải danh sách đối tác!', error);
            });

        // Fetch tin tức Cooperation
        const requestUrl = `news/getByCategoryName?&page=1&size=1&unit=Home&categoryName=Cooperation&status=1&highlight=1`;
        axiosClient.get(requestUrl)
            .then(response => {
                setInfoCoop(response.data[0]);
                setLinkImage(response.data[0]['image_URL']);
                setLoaded(true);
            })
            .catch(error => {
                console.error('There was an error!', error);
                setLoaded(true);
            });
    }, []);

    const settings = {
        dots: false,
        infinite: listPartners.length > 8,
        speed: 2000,
        slidesToShow: 8,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 6000,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 3,
                    infinite: listPartners.length > 6
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className="wp-cooperation">
            <div className="cooperation">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="co-title">
                                <p style={{ color: '#FFFFFF', fontWeight: '700' }}>
                                    {intl.formatMessage({ id: 'Cooperation' })}
                                </p>
                                <div className="co-view">
                                    <Link to={`/partner/list`}> 
                                        {intl.formatMessage({ id: 'View All' })} 
                                    </Link>
                                </div>
                            </div>
                        </Col>
                        
                        <Col md="12" id='coorperationSlider'>
                            {listPartners && listPartners.length > 0 && (
                                <Slider {...settings}>
                                    {listPartners.map((item, index) => {
                                        return (
                                            <div key={item.id || index} className="partner-card-wrapper">
                                                <a 
                                                    href={item.link} 
                                                    className="partner-card-link" 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    {/* Khung nền trắng cố định chứa Logo & Overlay */}
                                                    <div className="partner-logo-box">
                                                        <LazyLoadImage 
                                                            src={`${IMAGE_BASE_URL}/${item.image}`} 
                                                            alt={item.title || "Partner Logo"} 
                                                            className="partner-logo-img"
                                                        />

                                                        {/* Lớp mờ phủ đè hiển thị tên khi hover */}
                                                        <div className="partner-overlay">
                                                            <span className="partner-name">
                                                                {item.title}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        );
                                    })}
                                </Slider>
                            )}
                        </Col>
                    </Row>

                    <Row className="wp-info">
                        {!loaded ? (
                            <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" />
                        ) : (
                            <>
                                <Col md="3" sm="12" className="co-banner">
                                    <a 
                                        className="image-with-hover-overlay image-hover-zoom" 
                                        href={`/listnews/detail/${infoCoop.title}`} 
                                        style={{ width: '100%', height: '100%' }}
                                    >
                                        <img 
                                            src={`${IMAGE_BASE_URL}/${linkImage}`} 
                                            className="full-img" 
                                            alt={infoCoop.title}
                                            style={{ width: '100%', height: '100%' }}
                                        />
                                    </a>
                                </Col>
                                
                                <Col md="9" sm="12" className="co-info">
                                    <p className="co-info-1" style={{ color: '#FFFFFF', fontWeight: '700', marginBottom: '0.3em' }}>
                                        <Link to={`/listnews/detail/${infoCoop.title}`} style={{ color: '#FFFFFF', fontWeight: '700', marginBottom: '0.3em', fontSize: '24px' }}>
                                            {infoCoop.title}
                                        </Link>
                                    </p>
                                    <p style={{ color: '#FABD03', fontSize: '13px', fontWeight: '400', marginBottom: '1em' }}>
                                        {toDateTimeStringEnglish(infoCoop.date_created)}
                                    </p>
                                    <p className="co-info-2">
                                        <Link to={`/listnews/detail/${infoCoop.title}`} style={{ color: '#FFFFFF', fontWeight: '400', marginBottom: '0.9em' }}>
                                            {infoCoop.description}
                                        </Link>
                                    </p>
                                    <Link style={{ color: '#FABD03', fontSize: '16px', fontWeight: '700', marginBottom: '4px', textDecorationLine: 'underline' }} to={`/news/cooperation`}>
                                        {intl.formatMessage({ id: 'View All' })}
                                    </Link>
                                </Col>
                            </>
                        )}
                    </Row>
                </Container>
            </div>
        </div>
    );
}